import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AccountingItemsTable from "../../components/accountingItemsTable";
import ViewLayout from "../../components/viewLayout";
import TableHelper from "../../components/tableHelper";
import { useFetch } from "../../utils/fetchHook";
import { useLocation } from "react-router-dom";
import { getCookie } from "../../jwt/_helpers/cookie";
import { findAccountingReportById } from "../../utils/accountingDemoHelpers";

const AccountingBreakdown = props => {
  const createdReports = useSelector(
    state => state.accountingReports?.created || [],
  );

  const token = getCookie("token");

  const location = useLocation();
  const accountingReportID = location.pathname.split("/")[2];
  const [apiData, error, loading] = useFetch("GET",`accounting_reports/${accountingReportID}/`, token);

  const [tableData, setTableData] = useState([]);


  useEffect(() => {
    const createdMatch = createdReports.find(
      row => String(row.id) === String(accountingReportID),
    );
    const report = createdMatch || findAccountingReportById(accountingReportID) || apiData;

    if (Array.isArray(report?.revenueshareholder_reports)) {
      setTableData(report.revenueshareholder_reports);
    }
  }, [apiData, accountingReportID, createdReports]);

  const tableProps = {
    tableData,
    error,
    loading,
  };

  return (
    <>
      {loading ? (
        <TableHelper loading />
      ) : error ? (
        <TableHelper error />
      ) :  (
        <div>
          <ViewLayout title={"Accounting Breakdown"}>
            <AccountingItemsTable
              {...tableProps}
            />
          </ViewLayout>
        </div>
      )}
    </>
  );
};

export default AccountingBreakdown;
